import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment-timezone';
import LocalizedDatePicker from 'app/custom-widgets/LocalizedDatePicker';

const ControlledDatePicker = ({ name, label, ...rest }) => {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                let { value } = field;
                if (value && !moment.isMoment(value)) value = moment(value);
                return (
                    <LocalizedDatePicker
                        {...field}
                        value={value}
                        label={label}
                        {...rest}
                        // wrap
                    />
                );
            }}
            // wrap
        />
    );
};

export default ControlledDatePicker;
